import { render, staticRenderFns } from "./CustomizationAddProduct.vue?vue&type=template&id=11049b7a&scoped=true"
import script from "./CustomizationAddProduct.vue?vue&type=script&lang=js"
export * from "./CustomizationAddProduct.vue?vue&type=script&lang=js"
import style0 from "./CustomizationAddProduct.vue?vue&type=style&index=0&id=11049b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11049b7a",
  null
  
)

export default component.exports